<template>
    <div v-if="show" class="lds-spinner">
        <div class="spinner flex-column items-center justify-center">
          <i class="el-icon-loading" style="color: #FFFFFF;font-size: 18px;font-weight: bold"></i>
          <div class="loading-text">Loading...</div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'loadingView',
        props: {
            show: Boolean
        },
        data() {
            return {
            }

        }
    }
</script>
<style lang="less" scoped>
    .lds-spinner{
        position: fixed;
        top:0;
        left:0;
        width:100%;
        height:100%;
        background: rgba(0,0,0,0.2);
        z-index: 8;
    }
    .spinner {
        /*width: 25px;*/
        /*height: 25px;*/
        position:absolute;
        top:50%;
        left:50%;
        transform: translate(-50%);
        .demo-spin-icon-load{
            animation: ani-demo-spin 1s linear infinite;
        }
        @keyframes ani-demo-spin {
            from { transform: rotate(0deg);}
            50%  { transform: rotate(180deg);}
            to   { transform: rotate(360deg);}
        }
        /*.double-bounce1, .double-bounce2 {*/
        /*    width: 25px;*/
        /*    height: 25px;*/
        /*    border-radius: 50%;*/
        /*    background-color: #FF000F;*/
        /*    opacity: 0.6;*/
        /*    position: absolute;*/
        /*    top: 0;*/
        /*    left: 0;*/
        /*    -webkit-animation: bounce 2.0s infinite ease-in-out;*/
        /*    animation: bounce 2.0s infinite ease-in-out;*/
        /*}*/
        /*.double-bounce2 {*/
        /*    -webkit-animation-delay: -1.0s;*/
        /*    animation-delay: -1.0s;*/
        /*}*/
    }

    @-webkit-keyframes bounce {
        0%, 100% { -webkit-transform: scale(0.0) }
        50% { -webkit-transform: scale(1.0) }
    }

    @keyframes bounce {
        0%, 100% {
            transform: scale(0.0);
            -webkit-transform: scale(0.0);
        } 50% {
              transform: scale(1.0);
              -webkit-transform: scale(1.0);
          }
    }
    .loading-text{
      color: white;
      margin-top: 10px;
    }
</style>
